import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NavBar from '../../components/NavBarSearchSong';
import { Grid } from '@material-ui/core';

// Images
import Settings from '../../assets/Settings.png';

// Components
import SearchBox from '../../components/SearchBox';
import PlaylistTable from '../../components/PlaylistTable';

import { playlistActions } from '../../actions';
import { playlistStore } from '../../store';
import { Button } from '../../components';
import { size } from 'lodash';

const RadioPlaylist = () => {
  const LIMIT = 50;
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState({ page: 1, isLast: false });
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  // Zustand
  const { playlists, setPlaylists } = playlistStore((state) => ({
    playlists: state.radioPlaylists,
    setPlaylists: state.setRadioPlaylists,
  }));

  // Detect When user scroll to bottom of table
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && !currentPage.isLast) {
      fetchMorePlaylists();
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const playlistsFromBE = await playlistActions.fetchAllPlaylist({
        page: 1,
        type: 'RADIO',
        limit: LIMIT,
        search: searchInput,
      });

      setPlaylists(playlistsFromBE);
      setIsLoading(false);
      setCurrentPage((prev) => ({
        page: prev.page + 1,
        isLast: size(playlistsFromBE) < LIMIT,
      }));
    })();
  }, [searchInput]);

  // Fetch the data from the Playlist API
  const fetchMorePlaylists = async () => {
    if (isFetchingMore || currentPage.isLast) return;
    setIsFetchingMore(true);
    const playlistsFromBE = await playlistActions.fetchAllPlaylist({
      page: currentPage.page,
      limit: LIMIT,
      search: searchInput,
      type: 'UNLIMITED',
    });

    setPlaylists([...playlists, ...playlistsFromBE]);
    setIsFetchingMore(false);
    setCurrentPage((prev) => ({
      page: prev.page + 1,
      isLast: size(playlistsFromBE) < LIMIT,
    }));
  };
  console.log(playlists, 'playlists');
  return (
    <>
      <NavBar data="Radio Playlist" icon={Settings} currentRouteName="Radio Playlist" breadcrumbsPath={[{ name: 'Playlist' }]} />
      <div className="content" style={{ marginTop: 73 }}>
        <div style={{ marginBottom: 12, width: '100%' }}>
          <Grid container style={{ justifyContent: 'space-between' }}>
            <SearchBox onChange={(e) => setSearchInput(e)} />
            <Grid item>
              <Button
                onClick={() => {
                  history.push('/radio-new-playlist?plan=radio');
                }}
                className="round_btn"
              >
                Create New Playlist
              </Button>
            </Grid>
          </Grid>
        </div>
        <PlaylistTable initialLoading={isLoading} tableLoading={isFetchingMore} data={playlists} type="RADIO" onScroll={handleScroll} />
      </div>
    </>
  );
};

export default RadioPlaylist;

